import { storyblokInit as s } from "./storyblok-js.mjs";
import { BlockTypes as g, MarkTypes as C, TextTypes as d, apiPlugin as f, loadStoryblokBridge as S, registerStoryblokBridge as x, renderRichText as F, richTextResolver as T, storyblokEditable as A, registerStoryblokBridge as B } from "./storyblok-js.mjs";
import { default as h } from "./storyblok-component.mjs";
let t = null, e = {}, r = !1, l = null;
const b = () => (t || console.error(
  "You can't use getStoryblokApi if you're not loading apiPlugin."
), t), c = (o) => (e = o, e), k = (o) => e[o] ? e[o] : (console.error(`Component ${o} doesn't exist.`), !1), i = () => r, p = () => l, m = (o = {}) => {
  const { storyblokApi: n } = s(o);
  t = n, e = o.components, r = o.enableFallbackComponent, l = o.customFallbackComponent;
};
export {
  g as BlockTypes,
  C as MarkTypes,
  h as StoryblokComponent,
  d as TextTypes,
  f as apiPlugin,
  k as getComponent,
  p as getCustomFallbackComponent,
  i as getEnableFallbackComponent,
  b as getStoryblokApi,
  S as loadStoryblokBridge,
  x as registerStoryblokBridge,
  F as renderRichText,
  T as richTextResolver,
  c as setComponents,
  A as storyblokEditable,
  m as storyblokInit,
  b as useStoryblokApi,
  B as useStoryblokBridge
};
